import { createContext, useContext } from "react";
import { createMorphemeRouteBodyWindow } from "#morpheme-route-body-window";
export type BodyWindow = ReturnType<typeof createMorphemeRouteBodyWindow>;
export type BodyRoute = { active: boolean; owner: BodyWindow; routeKey: string };
export const WindowContext = createContext<{ isFocused: boolean; owner: BodyWindow } | null>(null);
export const RouteBodyContext = createContext<BodyRoute | null>(null);
export const BodyReadyContext = createContext<(() => void) | undefined>(undefined);

export function useMorphemeRouteBodyReady() {
  return useContext(BodyReadyContext);
}
